import React from 'react'
import { t } from 'ttag'

import { Modal } from 'components/shared/Modal/Modal'
import { CompetenciesFormFields } from 'components/shared/CompetenciesFormFields/CompetenciesFormFields'
import { CompetencyDescription } from 'components/shared/CompetencyDescription/CompetencyDescription'
import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'
import { useInternalState } from './hooks'
import { DefaultDescription } from 'components/modals/common/JobPositionModal/tabs/Competencies/common/DefaultDescription/DefaultDescription'

import {
  getCategoryOrder,
  getCompetencies,
} from 'components/shared/CompetenciesFormFields/helpers'

import styles from './EditCompetenciesModal.module.scss'
import { useActiveCategory } from 'hooks'

export const EditCompetenciesModal = ({
  onCancel,
  onClose,
  onConfirm,
  skills,
  isOpen,
}) => {
  const {
    state: {
      form: { competencies, control, formState },
      language,
    },
    handlers: { handleCancel, handleClose, handleConfirm },
  } = useInternalState({ skills }, { onCancel, onClose, onConfirm })

  const categories = getCompetencies(competencies.fields, language)
  const categoryOrder = getCategoryOrder(language)

  const {
    output: activeCategory,
    handleOutputChange,
    handleReset,
    hasOutput: hasActiveCategory,
  } = useActiveCategory()

  return (
    <Modal
      className={styles.modal}
      cancelLabel={t`Cancel`}
      confirmLabel={t`Save`}
      title={t`Edit competencies`}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      isConfirmDisabled={!formState.isDirty}
      {...{ isOpen }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <h3
          className={styles.subtitle}
        >{t`Click on the competence to read more about it`}</h3>
        <div className={styles.skills}>
          <CompetenciesFormFields
            className={styles.competencies}
            order={categoryOrder}
            onClick={handleOutputChange}
            {...{
              activeCategory,
              categories,
              control,
              formState,
            }}
          />
          <aside className={styles.aside}>
            <DetailsCard
              title={hasActiveCategory ? activeCategory : t`About competencies`}
              onBackClick={handleReset}
              hasDefaultState={!hasActiveCategory}
            >
              {hasActiveCategory ? (
                <CompetencyDescription
                  competencies={
                    categories.reduce(
                      (
                        grouped,
                        { category, explanation, label, name },
                        index,
                      ) => {
                        if (!grouped[category]) grouped[category] = []
                        grouped[category].push({
                          explanation,
                          index,
                          label,
                          name,
                        })
                        return grouped
                      },
                      {},
                    )[activeCategory ?? '']
                  }
                />
              ) : (
                <DefaultDescription />
              )}
            </DetailsCard>
          </aside>
        </div>
      </Modal.Content>
      <Modal.Footer />
    </Modal>
  )
}
